/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderArrowUpRight: {
  name: 'folder-arrow-up-right';
  data: string;
} = {
  name: 'folder-arrow-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v5a1 1 0 1 0 2 0V5h4.586L11 7.414A2 2 0 0 0 12.414 8H20v10h-8a1 1 0 1 0 0 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.586L10 3.586A2 2 0 0 0 8.586 3H4ZM2 14a1 1 0 0 0 1 1h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414L7 16.414V19a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Z" fill="currentColor"/></svg>`,
};
